import { Page } from '@/components/page';
import { UserInvoices } from '@/components/user-invoices';

export function Invoices() {
  return (
    <Page title="Invoices">
      <UserInvoices />
    </Page>
  );
}